(function() {
  if (window.__pdpTrustScroll) return;
  window.__pdpTrustScroll = true;
  document.addEventListener('click', function(e) {
    var link = e.target.closest && e.target.closest('.pdp-trust__row a[href="#judgeme_product_reviews"]');
    if (!link) return;
    var target = document.getElementById('judgeme_product_reviews');
    if (!target) return;
    e.preventDefault();
    var header = document.querySelector('.fitspire-header__container') || document.querySelector('.fitspire-header');
    var snav = document.querySelector('[data-pdp-snav]');
    var offset = (header ? header.offsetHeight : 0) + (snav ? snav.offsetHeight : 0) + 12;
    window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - offset, behavior: 'smooth' });
  });
})();
